// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles_avatar__dBEWn"};